module.exports = __webpack_public_path__ + "static/media/status-changed-16.0305d047.svg";